export default function stripHtml(text) {
    return text.replace(/<\/?[^>]+(>|$)/g, "");
};



// WEBPACK FOOTER //
// ./src/scripts/StripHtml.js